//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'

import ImagePicker from 'components/Shared/ImagePicker/Index'

const FieldComponent = ({
  value,
  onChange,
  recommendationSize,
  uploadButtonTitle,
  updateButtonTitle,
}) => {
  let base64Content, contentType, filename
  if (value) {
    ({ base64Content, contentType, filename } = value)
  }

  return (
    <ImagePicker
      base64Content={base64Content}
      contentType={contentType}
      filename={filename}
      onChange={onChange}
      recommendationSize={recommendationSize}
      uploadButtonTitle={uploadButtonTitle}
      updateButtonTitle={updateButtonTitle}
    />
  )
}

FieldComponent.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  recommendationSize: PropTypes.string,
  uploadButtonTitle: PropTypes.string,
  updateButtonTitle: PropTypes.string,
}

const ImageField = ({ name, validate }) => {
  return (
    <Field
      allowNull
      name={name}
      validate={validate}
      parse={value => (value)}
    >
      {({ input, meta }) => {
        return (
          <FieldComponent
            value={input.value}
            onChange={input.onChange}
          />
        )
      }}
    </Field>
  )
}

ImageField.propTypes = {
  name: PropTypes.string,
  validate: PropTypes.func,
}

export default ImageField
